import { i as e, n as t, r as n, t as r } from "./dist-By11B3Nf.js";
import { a as i, n as a } from "./dist-7tgynhKG.js";
import { a as o, i as s, l as c, n as l, o as u, r as d, s as f, t as p } from "./es2015-Dfq2CQHn.js";
import { t as m } from "./dist-B3lndwlS.js";
import { t as h } from "./dist-CUIQpIad.js";
import * as g from "react";
import { Fragment as _, jsx as v } from "react/jsx-runtime";
//#region ../../node_modules/.pnpm/@radix-ui+react-dialog@1.1.20_@types+react-dom@19.2.3_@types+react@19.2.17__@types+reac_acaa8766c54ae0ab2a102c503c927ccc/node_modules/@radix-ui/react-dialog/dist/index.mjs
var y = Object.defineProperty, b = (e, t) => y(e, "name", {
	value: t,
	configurable: !0
}), x = "Dialog", [S, C] = e(x), [w, T] = S(x), E = /* @__PURE__ */ b((e) => {
	let { __scopeDialog: t, children: n, open: i, defaultOpen: a, onOpenChange: o, modal: s = !0 } = e, l = g.useRef(null), u = g.useRef(null), [d, f] = r({
		prop: i,
		defaultProp: a ?? !1,
		onChange: o,
		caller: x
	}), [p, m] = g.useState(0), [h, _] = g.useState(0);
	return /* @__PURE__ */ v(w, {
		scope: t,
		triggerRef: l,
		contentRef: u,
		contentId: c(),
		titleId: c(),
		descriptionId: c(),
		titlePresent: p > 0,
		descriptionPresent: h > 0,
		setTitleCount: m,
		setDescriptionCount: _,
		open: d,
		onOpenChange: f,
		onOpenToggle: g.useCallback(() => f((e) => !e), [f]),
		modal: s,
		children: n
	});
}, "Dialog"), D = "DialogTrigger", O = /* @__PURE__ */ g.forwardRef(/* @__PURE__ */ b(function(e, t) {
	let { __scopeDialog: r, ...a } = e, o = T(D, r), s = i(t, o.triggerRef);
	return /* @__PURE__ */ v(m.button, {
		type: "button",
		"aria-haspopup": "dialog",
		"aria-expanded": o.open,
		"aria-controls": o.open ? o.contentId : void 0,
		"data-state": J(o.open),
		...a,
		ref: s,
		onClick: n(e.onClick, o.onOpenToggle)
	});
}, "DialogTrigger")), k = "DialogPortal", [A, j] = S(k, { forceMount: void 0 }), M = /* @__PURE__ */ b((e) => {
	let { __scopeDialog: t, forceMount: n, children: r, container: i } = e, a = T(k, t);
	return /* @__PURE__ */ v(A, {
		scope: t,
		forceMount: n,
		children: g.Children.map(r, (e) => /* @__PURE__ */ v(h, {
			present: n || a.open,
			children: /* @__PURE__ */ v(s, {
				asChild: !0,
				container: i,
				children: e
			})
		}))
	});
}, "DialogPortal"), N = "DialogOverlay", P = /* @__PURE__ */ g.forwardRef(/* @__PURE__ */ b(function(e, t) {
	let n = j(N, e.__scopeDialog), { forceMount: r = n.forceMount, ...i } = e, a = T(N, e.__scopeDialog);
	return a.modal ? /* @__PURE__ */ v(h, {
		present: r || a.open,
		children: /* @__PURE__ */ v(I, {
			...i,
			ref: t
		})
	}) : null;
}, "DialogOverlay")), F = a("DialogOverlay.RemoveScroll"), I = /* @__PURE__ */ g.forwardRef(/* @__PURE__ */ b(function(e, t) {
	let { __scopeDialog: n, ...r } = e, a = T(N, n), o = i(t, f());
	return /* @__PURE__ */ v(l, {
		as: F,
		allowPinchZoom: !0,
		shards: [a.contentRef],
		children: /* @__PURE__ */ v(m.div, {
			"data-state": J(a.open),
			...r,
			ref: o,
			style: {
				pointerEvents: "auto",
				...r.style
			}
		})
	});
}, "DialogOverlayImpl")), L = "DialogContent", R = /* @__PURE__ */ g.forwardRef(/* @__PURE__ */ b(function(e, t) {
	let n = j(L, e.__scopeDialog), { forceMount: r = n.forceMount, ...i } = e, a = T(L, e.__scopeDialog);
	return /* @__PURE__ */ v(h, {
		present: r || a.open,
		children: a.modal ? /* @__PURE__ */ v(z, {
			...i,
			ref: t
		}) : /* @__PURE__ */ v(B, {
			...i,
			ref: t
		})
	});
}, "DialogContent")), z = /* @__PURE__ */ g.forwardRef(/* @__PURE__ */ b(function(e, t) {
	let r = T(L, e.__scopeDialog), a = g.useRef(null), o = i(t, r.contentRef, a);
	return g.useEffect(() => {
		let e = a.current;
		if (e) return p(e);
	}, []), /* @__PURE__ */ v(V, {
		...e,
		ref: o,
		trapFocus: r.open,
		disableOutsidePointerEvents: r.open,
		onCloseAutoFocus: n(e.onCloseAutoFocus, (e) => {
			e.preventDefault(), r.triggerRef.current?.focus();
		}),
		onPointerDownOutside: n(e.onPointerDownOutside, (e) => {
			let t = e.detail.originalEvent, n = t.button === 0 && t.ctrlKey === !0;
			(t.button === 2 || n) && e.preventDefault();
		}),
		onFocusOutside: n(e.onFocusOutside, (e) => e.preventDefault())
	});
}, "DialogContentModal")), B = /* @__PURE__ */ g.forwardRef(/* @__PURE__ */ b(function(e, t) {
	let n = T(L, e.__scopeDialog), r = g.useRef(!1), i = g.useRef(!1);
	return /* @__PURE__ */ v(V, {
		...e,
		ref: t,
		trapFocus: !1,
		disableOutsidePointerEvents: !1,
		onCloseAutoFocus: (t) => {
			e.onCloseAutoFocus?.(t), t.defaultPrevented || (r.current || n.triggerRef.current?.focus(), t.preventDefault()), r.current = !1, i.current = !1;
		},
		onInteractOutside: (t) => {
			e.onInteractOutside?.(t), t.defaultPrevented || (r.current = !0, t.detail.originalEvent.type === "pointerdown" && (i.current = !0));
			let a = t.target;
			n.triggerRef.current?.contains(a) && t.preventDefault(), t.detail.originalEvent.type === "focusin" && i.current && t.preventDefault();
		}
	});
}, "DialogContentNonModal")), V = /* @__PURE__ */ g.forwardRef(/* @__PURE__ */ b(function(e, t) {
	let { __scopeDialog: n, trapFocus: r, onOpenAutoFocus: i, onCloseAutoFocus: a, ...s } = e, c = T(L, n);
	return d(), /* @__PURE__ */ v(_, { children: /* @__PURE__ */ v(o, {
		asChild: !0,
		loop: !0,
		trapped: r,
		onMountAutoFocus: i,
		onUnmountAutoFocus: a,
		children: /* @__PURE__ */ v(u, {
			role: "dialog",
			id: c.contentId,
			"aria-describedby": c.descriptionPresent ? c.descriptionId : void 0,
			"aria-labelledby": c.titlePresent ? c.titleId : void 0,
			"data-state": J(c.open),
			...s,
			ref: t,
			deferPointerDownOutside: !0,
			onDismiss: () => c.onOpenChange(!1)
		})
	}) });
}, "DialogContentImpl")), H = "DialogTitle", U = /* @__PURE__ */ g.forwardRef(/* @__PURE__ */ b(function(e, n) {
	let { __scopeDialog: r, ...i } = e, a = T(H, r), { setTitleCount: o } = a;
	return t(() => (o((e) => e + 1), () => o((e) => e - 1)), [o]), /* @__PURE__ */ v(m.h2, {
		id: a.titleId,
		...i,
		ref: n
	});
}, "DialogTitle")), W = "DialogDescription", G = /* @__PURE__ */ g.forwardRef(/* @__PURE__ */ b(function(e, n) {
	let { __scopeDialog: r, ...i } = e, a = T(W, r), { setDescriptionCount: o } = a;
	return t(() => (o((e) => e + 1), () => o((e) => e - 1)), [o]), /* @__PURE__ */ v(m.p, {
		id: a.descriptionId,
		...i,
		ref: n
	});
}, "DialogDescription")), K = "DialogClose", q = /* @__PURE__ */ g.forwardRef(/* @__PURE__ */ b(function(e, t) {
	let { __scopeDialog: r, ...i } = e, a = T(K, r);
	return /* @__PURE__ */ v(m.button, {
		type: "button",
		...i,
		ref: t,
		onClick: n(e.onClick, () => a.onOpenChange(!1))
	});
}, "DialogClose"));
function J(e) {
	return e ? "open" : "closed";
}
b(J, "getState");
//#endregion
export { P as a, O as c, G as i, C as l, q as n, M as o, R as r, U as s, E as t };

//# sourceMappingURL=dist-BWsUe_id.js.map